/* GlamStation theme.js — small interactions, no framework */

(function () {
  'use strict';

  // ─── Mobile drawer ─────────────────────────────────────────
  const drawer = document.querySelector('[data-gs-drawer]');
  const burger = document.querySelector('[data-gs-drawer-open]');
  const closeBtn = document.querySelector('[data-gs-drawer-close]');
  const scrim = document.querySelector('[data-gs-drawer-scrim]');

  function openMobileDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openMobileDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileDrawer);
  if (scrim) scrim.addEventListener('click', closeMobileDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileDrawer();
      closeCartDrawer();
    }
  });

  // ─── Marquee duplication ───────────────────────────────────
  document.querySelectorAll('[data-gs-marquee]').forEach(function (el) {
    const track = el.querySelector('.gs-marquee__track');
    if (!track) return;
    const html = track.innerHTML;
    track.innerHTML = html + html + html;
  });

  // ─── Money formatter ───────────────────────────────────────
  // Shopify ships prices as cents. §6: un solo formato de precio en todo
  // el tema — "$470", sin decimales cuando terminan en .00 (mismo criterio
  // que el filtro Liquid money_without_trailing_zeros).
  const moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN';
  function formatMoney(cents) {
    const n = (cents || 0) / 100;
    const hasCents = Math.round(n * 100) % 100 !== 0;
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: moneyFormat, minimumFractionDigits: hasCents ? 2 : 0 }).format(n);
    } catch (e) {
      return '$' + (hasCents ? n.toFixed(2) : n.toFixed(0));
    }
  }

  // ─── Cart count ────────────────────────────────────────────
  function setCartCount(count) {
    document.querySelectorAll('[data-gs-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      if (count > 0) el.removeAttribute('hidden');
    });
  }

  // ─── Cart drawer ──────────────────────────────────────────
  const cartDrawer = document.querySelector('[data-gs-cart-drawer]');
  const cartList = document.querySelector('[data-gs-cart-list]');
  const cartEmpty = document.querySelector('[data-gs-cart-empty]');
  const cartFoot = document.querySelector('[data-gs-cart-foot]');
  const cartTitle = document.querySelector('[data-gs-cart-title]');
  const cartSubtotal = document.querySelector('[data-gs-cart-subtotal]');
  const lineTpl = document.querySelector('[data-gs-cart-line-template]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-gs-cart-close], [data-gs-cart-close-link]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (el.tagName === 'A' && el.hasAttribute('href')) return;
      e.preventDefault();
      closeCartDrawer();
    });
  });

  // Open drawer when clicking cart icon (only elements with data-gs-cart-open opt in)
  document.querySelectorAll('[data-gs-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      fetchCart().then(renderCart).then(openCartDrawer);
    });
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    if (!cartDrawer || !cartList) return cart;
    setCartCount(cart.item_count);
    cartList.innerHTML = '';

    if (cart.item_count === 0) {
      if (cartTitle) cartTitle.textContent = 'tu bolsa.';
      if (cartEmpty) cartEmpty.removeAttribute('hidden');
      if (cartFoot) cartFoot.setAttribute('hidden', '');
      return cart;
    }

    if (cartEmpty) cartEmpty.setAttribute('hidden', '');
    if (cartFoot) cartFoot.removeAttribute('hidden');
    if (cartTitle) cartTitle.textContent = cart.item_count + (cart.item_count === 1 ? ' producto.' : ' productos.');
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    cart.items.forEach(function (item) {
      if (!lineTpl) return;
      const node = lineTpl.content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      const imgUrl = node.querySelector('[data-line-url]');
      const img = node.querySelector('[data-line-img]');
      const brand = node.querySelector('[data-line-brand]');
      const titleUrl = node.querySelector('[data-line-title-url]');
      const title = node.querySelector('[data-line-title]');
      const variant = node.querySelector('[data-line-variant]');
      const qty = node.querySelector('[data-line-qty]');
      const price = node.querySelector('[data-line-price]');

      if (imgUrl) imgUrl.href = item.url;
      if (titleUrl) titleUrl.href = item.url;
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2');
          img.alt = item.title;
        } else {
          img.style.background = 'var(--gs-cream-2)';
          img.style.minHeight = '80px';
        }
      }
      if (brand) brand.textContent = (item.vendor || '').toLowerCase();
      if (title) {
        // los títulos vienen como "Marca - Nombre"; la marca ya va arriba,
        // así que se quita el prefijo (igual que en las tarjetas)
        let t = item.product_title || '';
        if (item.vendor) {
          const v = item.vendor.toLowerCase();
          const low = t.toLowerCase();
          if (low.indexOf(v + ' - ') === 0 || low.indexOf(v + ' | ') === 0) t = t.slice(v.length + 3);
        }
        title.textContent = t.trim().toLowerCase();
      }
      if (variant && item.variant_title && !item.variant_title.toLowerCase().includes('default')) {
        variant.textContent = item.variant_title.toLowerCase();
        variant.removeAttribute('hidden');
      }
      if (qty) qty.textContent = item.quantity;
      if (price) price.textContent = formatMoney(item.final_line_price);

      node.querySelector('[data-line-inc]').addEventListener('click', function () {
        updateLine(item.key, item.quantity + 1);
      });
      node.querySelector('[data-line-dec]').addEventListener('click', function () {
        updateLine(item.key, Math.max(0, item.quantity - 1));
      });
      node.querySelector('[data-line-remove]').addEventListener('click', function () {
        updateLine(item.key, 0);
      });

      cartList.appendChild(node);
    });

    return cart;
  }

  function updateLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // If we're on the cart page, reload to keep server-rendered cart in sync.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      });
  }

  // ─── AJAX add-to-cart ──────────────────────────────────────
  document.querySelectorAll('form[action$="/cart/add"], form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'agregando…';
      }

      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          renderCart(cart);
          openCartDrawer();
          if (submitBtn) {
            submitBtn.innerHTML = '✓ agregado';
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalText;
            }, 1500);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(function (err) {
          console.error('add-to-cart error', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = (err && err.description) ? 'sin stock' : 'error · reintenta';
            setTimeout(function () { submitBtn.innerHTML = originalText; }, 2000);
          }
        });
    });
  });

  // Initial cart count refresh. Si el fetch falla, no dejar el título del
  // drawer pegado en "cargando…" (§7.1) — cae a un texto neutro.
  fetchCart().then(renderCart).catch(function () {
    if (cartTitle) cartTitle.textContent = 'tu bolsa.';
  });

  // Listen to legacy cart updates
  document.addEventListener('cart:updated', function (e) {
    if (e.detail) setCartCount(e.detail.item_count);
  });

  // ─── PDP gallery swap + counter sync ───────────────────────
  document.querySelectorAll('[data-gs-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gs-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gs-gallery-thumb]');
    const counter = gallery.querySelector('[data-gs-gallery-counter-current]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        const full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-current', 'false'); });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        if (counter) {
          const idx = thumb.getAttribute('data-gs-gallery-index') || '1';
          counter.textContent = ('00' + idx).slice(-2);
        }
      });
    });
  });

  // ─── PDP save (visual toggle only — no persistence until Fase 6) ──
  document.querySelectorAll('[data-gs-save]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('is-saved');
      const saved = btn.classList.contains('is-saved');
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  });

  // ─── Expandable accordions (PDP sections) ──────────────────
  document.querySelectorAll('[data-gs-accordion]').forEach(function (acc) {
    const head = acc.querySelector('[data-gs-accordion-head]');
    if (!head) return;
    head.addEventListener('click', function () {
      acc.classList.toggle('is-open');
      const expanded = acc.classList.contains('is-open');
      head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });

  // ─── Cart page +/- controls ───────────────────────────────
  document.querySelectorAll('[data-cart-page-qty]').forEach(function (input) {
    const key = input.dataset.key;
    const dec = document.querySelector('[data-cart-page-dec][data-key="' + key + '"]');
    const inc = document.querySelector('[data-cart-page-inc][data-key="' + key + '"]');
    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value, 10) - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // ─── PDP quantity controls + total/sticky sync ─────────────
  document.querySelectorAll('[data-gs-qty-input]').forEach(function (input) {
    const dec = input.parentElement.querySelector('[data-gs-qty-dec]');
    const inc = input.parentElement.querySelector('[data-gs-qty-inc]');
    // Reach the price node — it lives on the main info column, not inside .gs-pdp__qty.
    const priceNode = document.querySelector('[data-gs-price-pesos]');
    const totalDisp = document.querySelector('[data-gs-total-display]');
    const stickyQty = document.querySelector('[data-gs-sticky-qty]');
    const unitPesos = priceNode ? parseInt(priceNode.getAttribute('data-gs-price-pesos'), 10) || 0 : 0;

    function syncDerived() {
      const q = Math.max(1, parseInt(input.value, 10) || 1);
      if (totalDisp && unitPesos) {
        totalDisp.textContent = '$' + (unitPesos * q).toLocaleString('es-MX');
      }
      if (stickyQty) stickyQty.textContent = String(q);
    }

    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      input.dispatchEvent(new Event('change'));
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change'));
    });
    input.addEventListener('change', syncDerived);
    input.addEventListener('input', syncDerived);
    syncDerived();
  });

  // ─── PDP variant picker ────────────────────────────────────
  // Antes esto SOLO pintaba el chip activo: el hidden name="id" se quedaba
  // en la primera variante, así que elegir "toast" agregaba "ribbon" al
  // carrito (el add es AJAX contra /cart/add.js, que resuelve por id de
  // variante y no por options[]). Ahora resuelve la combinación elegida
  // contra el JSON de variantes y reescribe id, precio y botón.
  (function initVariantPickers() {
    const form = document.querySelector('form[action$="/cart/add"]');
    const dataEl = document.querySelector('[data-gs-product-variants]');
    const groups = document.querySelectorAll('[data-gs-variant-options]');
    if (!groups.length) return;

    let variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { variants = []; }
    }

    function paintActive() {
      document.querySelectorAll('[data-gs-option-input]').forEach(function (r) {
        if (r.parentElement) r.parentElement.classList.toggle('is-active', r.checked);
      });
    }

    function selection() {
      // un valor por grupo de opción, en orden de posición
      return Array.from(groups).map(function (g) {
        const checked = g.querySelector('[data-gs-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function apply() {
      paintActive();
      if (!variants.length) return;
      const v = findVariant(selection());
      if (!v) return;

      const idInput = document.querySelector('[data-gs-variant-id]');
      if (idInput) idInput.value = v.id;

      const priceEl = document.querySelector('[data-gs-price]');
      if (priceEl) {
        priceEl.textContent = v.price;
        priceEl.setAttribute('data-gs-price-pesos', Math.round(v.price_cents / 100));
      }
      const compareEl = document.querySelector('[data-gs-compare]');
      if (compareEl) {
        if (v.compare_at) { compareEl.textContent = v.compare_at; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      document.querySelectorAll('.gs-pdp__sticky-price-now').forEach(function (el) { el.textContent = v.price; });

      const addBtn = form && form.querySelector('[type="submit"]');
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available
          ? 'añadir a la bolsa · <span data-gs-total-display>' + v.price + '</span>'
          : 'agotado';
      }
      document.querySelectorAll('[data-gs-sticky-add]').forEach(function (b) { b.disabled = !v.available; });

      // la foto sigue al tono: si la variante tiene foto asignada en
      // Shopify, se activa su miniatura (o se cambia la principal si el
      // producto no tiene miniaturas). Sin foto asignada, no se mueve.
      if (v.image) {
        const thumb = v.image_position && document.querySelector('[data-gs-gallery-thumb][data-gs-gallery-index="' + v.image_position + '"]');
        if (thumb) {
          thumb.click();
        } else {
          const mainImg = document.querySelector('[data-gs-gallery-main]');
          if (mainImg) mainImg.src = v.image;
        }
      }

      // deja la URL compartible con el tono elegido
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* no rompe la selección si el navegador no deja */ }

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: v }));
    }

    document.querySelectorAll('[data-gs-option-input]').forEach(function (r) {
      r.addEventListener('change', apply);
    });
    paintActive();
  })();

  // Note: the old initCollectionFilters() IIFE (client-side hide/show)
  // was removed in Fase C. Catalog filtering is now server-side via URL
  // params — every chip/pill/checkbox/concern is an <a href> link that
  // navigates to a new URL. Sort uses <select onchange="this.form.submit()">
  // inside a <form>. No JS needed for filter logic.

  // ─── Search submit ─────────────────────────────────────────
  document.querySelectorAll('[data-gs-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) {
        e.preventDefault();
        if (input) input.focus();
      }
    });
  });

  // ─── Búsqueda predictiva (/search/suggest.json) ─────────────
  // Mientras escribes, muestra hasta 6 productos y las marcas que
  // coinciden. Enter o la lupa siguen llevando a /search completo.
  (function initPredictive() {
    const esc = function (t) {
      return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    document.querySelectorAll('[data-gs-predictive]').forEach(function (form) {
      const input = form.querySelector('[data-gs-predictive-input]');
      const box = form.querySelector('[data-gs-predictive-results]');
      if (!input || !box) return;
      let timer = null;
      let lastQ = '';
      let ctrl = null;

      function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }

      function render(q, data) {
        const res = (data && data.resources && data.resources.results) || {};
        const products = res.products || [];
        const collections = (res.collections || []).slice(0, 4);
        if (!products.length && !collections.length) {
          box.innerHTML = '<p class="gs-predictive__empty">sin coincidencias para “' + esc(q) + '”.</p>';
        } else {
          let html = '';
          if (collections.length) {
            html += '<div class="gs-predictive__group"><span class="gs-predictive__label">★ marcas y categorías</span>';
            collections.forEach(function (c) {
              html += '<a class="gs-predictive__chip" href="' + esc(c.url) + '">' + esc((c.title || '').toLowerCase()) + '</a>';
            });
            html += '</div>';
          }
          if (products.length) {
            html += '<div class="gs-predictive__group gs-predictive__group--list"><span class="gs-predictive__label">★ productos</span>';
            products.forEach(function (p) {
              let title = p.title || '';
              const v = (p.vendor || '').toLowerCase();
              if (v && title.toLowerCase().indexOf(v + ' - ') === 0) title = title.slice(v.length + 3);
              const img = p.featured_image && p.featured_image.url
                ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="48" height="48" loading="lazy">'
                : '<span class="gs-predictive__ph" aria-hidden="true"></span>';
              html += '<a class="gs-predictive__item" href="' + esc(p.url) + '">' + img +
                '<span class="gs-predictive__txt"><span class="gs-predictive__brand">' + esc(v) + '</span>' +
                '<span class="gs-predictive__name">' + esc(title.toLowerCase()) + '</span></span>' +
                '<span class="gs-predictive__price">' + esc(formatMoney(Math.round(parseFloat(p.price) * 100))) + '</span></a>';
            });
            html += '</div>';
          }
          html += '<button type="submit" class="gs-predictive__all">ver todo para “' + esc(q) + '” →</button>';
          box.innerHTML = html;
        }
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function search() {
        const q = input.value.trim();
        if (q.length < 2) { close(); lastQ = ''; return; }
        if (q === lastQ) return;
        lastQ = q;
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) { if (input.value.trim() === q) render(q, data); })
          .catch(function () { /* red caída o abort: no se muestra nada */ });
      }

      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(search, 180);
      });
      input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  })();

  // ─── Collection filters · mobile bottom-sheet drawer (Fase C) ───
  // The desktop sidebar (.gs-filters) is always visible ≥ 920px via CSS.
  // The mobile drawer (.gs-bsheet) mirrors the same filter groups and
  // slides up from the bottom when the toolbar toggle is pressed. Backdrop
  // + ESC + outside-click close it. No filter logic here — all filter
  // changes are <a href> links that navigate to a new URL.
  const filtersToggle   = document.querySelector('[data-gs-filters-open]');
  const filtersSheet    = document.querySelector('[data-gs-filters-sheet]');
  const filtersBackdrop = document.querySelector('[data-gs-filters-backdrop]');
  const filtersClose    = document.querySelector('[data-gs-filters-close]');
  function openFiltersSheet() {
    if (!filtersSheet) return;
    filtersSheet.classList.add('is-open');
    filtersSheet.setAttribute('aria-hidden', 'false');
    if (filtersBackdrop) filtersBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFiltersSheet() {
    if (!filtersSheet) return;
    filtersSheet.classList.remove('is-open');
    filtersSheet.setAttribute('aria-hidden', 'true');
    if (filtersBackdrop) filtersBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (filtersToggle)   filtersToggle.addEventListener('click', openFiltersSheet);
  if (filtersClose)    filtersClose.addEventListener('click', closeFiltersSheet);
  if (filtersBackdrop) filtersBackdrop.addEventListener('click', closeFiltersSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFiltersSheet();
  });

  // ─── Collection client-side filter + sort (Fase C.1) ────────
  // Shopify Liquid doesn't expose URL query params (request.params
  // is not a thing — only design_mode/host/locale/origin/page_type/
  // path are available). Filters live entirely in the URL and are
  // applied client-side: read URLSearchParams, hide non-matching
  // cards via .is-hidden, re-order the grid by sort, render the
  // applied-chips toolbar, sync sidebar visual state, update counter.
  //
  // URL contract:
  //   ?filter.category=X       single
  //   ?filter.vendor=a,b,c     multi (comma-separated)
  //   ?filter.concern=a,b      multi
  //   ?filter.on_sale=1        bool
  //   ?filter.price_min=200    integer (MXN pesos)
  //   ?filter.price_max=800
  //   ?filter.sort=price-asc   manual|novedad|price-asc|price-desc|title-asc
  (function initCollectionFilterClient() {
    const grid = document.querySelector('[data-gs-cards-grid]');
    if (!grid) return;

    const cards      = Array.from(grid.querySelectorAll('[data-gs-card]'));
    const emptyEl    = document.querySelector('[data-gs-empty]');
    const chipsHost  = document.querySelector('[data-gs-applied-chips]');
    const sortSelect = document.querySelector('[data-gs-sort-select]');
    const priceForm  = document.querySelector('[data-gs-price-form]');

    function parseState() {
      const p = new URLSearchParams(location.search);
      return {
        category: p.get('filter.category') || '',
        vendor:  (p.get('filter.vendor')  || '').split(',').filter(Boolean),
        concern: (p.get('filter.concern') || '').split(',').filter(Boolean),
        onSale:   p.get('filter.on_sale') === '1',
        priceMin: parseInt(p.get('filter.price_min') || '', 10) || null,
        priceMax: parseInt(p.get('filter.price_max') || '', 10) || null,
        sort:     p.get('filter.sort') || 'manual',
      };
    }

    function buildURL(state) {
      const p = new URLSearchParams();
      if (state.category) p.set('filter.category', state.category);
      if (state.vendor.length)  p.set('filter.vendor',  state.vendor.join(','));
      if (state.concern.length) p.set('filter.concern', state.concern.join(','));
      if (state.onSale) p.set('filter.on_sale', '1');
      if (state.priceMin != null) p.set('filter.price_min', state.priceMin);
      if (state.priceMax != null) p.set('filter.price_max', state.priceMax);
      if (state.sort && state.sort !== 'manual') p.set('filter.sort', state.sort);
      const qs = p.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }

    function matches(card, state) {
      const ds = card.dataset;
      if (state.category) {
        // Category filter reads data-type (Shopify product.type, handleized).
        // If data-type is missing (legacy/partial deploy), fall back to tags.
        if (ds.type) {
          if (ds.type !== state.category) return false;
        } else {
          const tags = (ds.tags || '').trim().split(/\s+/);
          if (tags.indexOf(state.category) === -1) return false;
        }
      }
      if (state.vendor.length && state.vendor.indexOf(ds.vendor) === -1) return false;
      if (state.concern.length) {
        const cs = (ds.concerns || '').trim().split(/\s+/);
        let any = false;
        for (let i = 0; i < state.concern.length; i++) {
          if (cs.indexOf(state.concern[i]) !== -1) { any = true; break; }
        }
        if (!any) return false;
      }
      if (state.onSale && ds.onSale !== '1') return false;
      const price = parseInt(ds.price, 10);
      if (state.priceMin != null && price < state.priceMin) return false;
      if (state.priceMax != null && price > state.priceMax) return false;
      return true;
    }

    function sortCards(state) {
      const arr = cards.slice();
      switch (state.sort) {
        case 'price-asc':
          arr.sort(function (a, b) { return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10); });
          break;
        case 'price-desc':
          arr.sort(function (a, b) { return parseInt(b.dataset.price, 10) - parseInt(a.dataset.price, 10); });
          break;
        case 'title-asc':
          arr.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
          break;
        case 'novedad':
          // No created_at on the card — fall back to reversed position so the
          // most recently added (last in collection order) lands at the top.
          arr.sort(function (a, b) { return parseInt(b.dataset.position, 10) - parseInt(a.dataset.position, 10); });
          break;
        default:
          arr.sort(function (a, b) { return parseInt(a.dataset.position, 10) - parseInt(b.dataset.position, 10); });
      }
      // agotados siempre al final, sin importar el orden elegido
      // (Array.sort es estable, así que el orden de arriba se respeta)
      arr.sort(function (a, b) { return (a.dataset.available === '0') - (b.dataset.available === '0'); });
      arr.forEach(function (c) { grid.appendChild(c); });
    }

    function renderChips(state) {
      if (!chipsHost) return;
      chipsHost.innerHTML = '';

      function addChip(label, onRemove, klass) {
        const a = document.createElement('a');
        a.href = '#';
        a.className = 'gs-chip' + (klass ? ' ' + klass : '');
        const text = document.createElement('span');
        text.textContent = label;
        const x = document.createElement('span');
        x.className = 'x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '×';
        a.appendChild(text);
        a.appendChild(x);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          onRemove();
          history.pushState({}, '', buildURL(state));
          applyState();
        });
        chipsHost.appendChild(a);
      }

      let activeCount = 0;
      if (state.category) {
        // El chip usa el mismo nombre en español que la pill del filtro;
        // si no la encuentra, cae al handle con espacios ("lip tint").
        const pill = document.querySelector('[data-gs-toggle-key="category"][data-gs-toggle-value="' + state.category + '"]');
        const catLabel = pill ? pill.textContent.trim() : state.category.replace(/-/g, ' ');
        addChip('★ ' + catLabel, function () { state.category = ''; }, 'gs-chip--fill');
        activeCount++;
      }
      state.vendor.slice().forEach(function (v) {
        addChip(v, function () { state.vendor = state.vendor.filter(function (x) { return x !== v; }); });
        activeCount++;
      });
      state.concern.slice().forEach(function (c) {
        addChip(c, function () { state.concern = state.concern.filter(function (x) { return x !== c; }); });
        activeCount++;
      });
      if (state.onSale) {
        addChip('★ en oferta', function () { state.onSale = false; }, 'gs-chip--coral');
        activeCount++;
      }
      if (state.priceMin != null || state.priceMax != null) {
        const lo = state.priceMin != null ? ('$' + state.priceMin) : '$0';
        const hi = state.priceMax != null ? ('$' + state.priceMax) : '$∞';
        addChip(lo + '–' + hi, function () { state.priceMin = null; state.priceMax = null; });
        activeCount++;
      }

      if (activeCount > 0) {
        const clear = document.createElement('a');
        clear.href = location.pathname;
        clear.className = 'gs-chip gs-chip--clear';
        clear.textContent = 'limpiar filtros →';
        clear.addEventListener('click', function (e) {
          e.preventDefault();
          history.pushState({}, '', location.pathname);
          applyState();
        });
        chipsHost.appendChild(clear);
      }

      // Mobile-toggle counter
      document.querySelectorAll('[data-gs-mobile-toggle-count]').forEach(function (el) {
        el.textContent = activeCount > 0 ? (' · ' + activeCount) : '';
      });
    }

    function updateSidebar(state) {
      document.querySelectorAll('[data-gs-toggle-key="category"]').forEach(function (el) {
        el.classList.toggle('on', el.dataset.gsToggleValue === state.category);
      });
      document.querySelectorAll('[data-gs-toggle-key="vendor"]').forEach(function (el) {
        el.classList.toggle('is-on', state.vendor.indexOf(el.dataset.gsToggleValue) !== -1);
      });
      document.querySelectorAll('[data-gs-toggle-key="concern"]').forEach(function (el) {
        el.classList.toggle('on', state.concern.indexOf(el.dataset.gsToggleValue) !== -1);
      });
      document.querySelectorAll('[data-gs-toggle-key="on_sale"]').forEach(function (el) {
        el.classList.toggle('is-on', state.onSale);
      });
      document.querySelectorAll('input[name="filter.price_min"]').forEach(function (i) {
        i.value = state.priceMin != null ? state.priceMin : '';
      });
      document.querySelectorAll('input[name="filter.price_max"]').forEach(function (i) {
        i.value = state.priceMax != null ? state.priceMax : '';
      });
      if (sortSelect) sortSelect.value = state.sort;
    }

    function applyState() {
      const state = parseState();
      let visible = 0;
      cards.forEach(function (card) {
        const ok = matches(card, state);
        card.classList.toggle('is-hidden', !ok);
        if (ok) visible++;
      });
      sortCards(state);
      document.querySelectorAll('[data-gs-matches-count]').forEach(function (el) {
        el.textContent = visible;
      });
      document.querySelectorAll('[data-gs-matches-plural]').forEach(function (el) {
        el.textContent = visible === 1 ? '' : 's';
      });
      if (emptyEl) emptyEl.classList.toggle('is-hidden', visible !== 0);
      grid.classList.toggle('is-hidden', visible === 0);
      renderChips(state);
      updateSidebar(state);
    }

    // Delegated click handler for all sidebar toggle links
    // (category pills, vendor checkboxes, concern chips, on_sale/drop toggles)
    document.addEventListener('click', function (e) {
      const target = e.target.closest('[data-gs-toggle-key]');
      if (!target) return;
      // skip the disabled "en tu station" toggle which is a <span> not <a>
      if (target.tagName !== 'A') return;
      e.preventDefault();
      const key = target.dataset.gsToggleKey;
      const value = target.dataset.gsToggleValue || '';
      const mode = target.dataset.gsToggleMode;
      const state = parseState();

      if (mode === 'single') {
        if (state.category === value) state.category = '';
        else state.category = value;
      } else if (mode === 'multi') {
        const list = state[key];
        if (!Array.isArray(list)) return;
        const idx = list.indexOf(value);
        if (idx >= 0) list.splice(idx, 1);
        else list.push(value);
      } else if (mode === 'bool') {
        if (key === 'on_sale') state.onSale = !state.onSale;
      }

      history.pushState({}, '', buildURL(state));
      applyState();
    });

    // Sort change
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const state = parseState();
        state.sort = sortSelect.value;
        history.pushState({}, '', buildURL(state));
        applyState();
      });
    }

    // Price form submit
    if (priceForm) {
      priceForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const state = parseState();
        const minVal = (priceForm.querySelector('input[name="filter.price_min"]').value || '').trim();
        const maxVal = (priceForm.querySelector('input[name="filter.price_max"]').value || '').trim();
        state.priceMin = minVal ? parseInt(minVal, 10) : null;
        state.priceMax = maxVal ? parseInt(maxVal, 10) : null;
        history.pushState({}, '', buildURL(state));
        applyState();
      });
    }

    // Delegated handler for "limpiar todo" (sidebar footer + empty-state CTA + dynamic chip)
    document.addEventListener('click', function (e) {
      const target = e.target.closest('[data-gs-clear-all]');
      if (!target) return;
      e.preventDefault();
      history.pushState({}, '', location.pathname);
      applyState();
    });

    // Browser back/forward — re-apply state from new URL
    window.addEventListener('popstate', applyState);

    // Initial run — sync UI to whatever URL was loaded
    applyState();
  })();

  // expose open/close for other scripts
  window.GS = window.GS || {};
  window.GS.openCart = function () { fetchCart().then(renderCart).then(openCartDrawer); };
  window.GS.closeCart = closeCartDrawer;
  window.GS.openFilters = openFiltersSheet;
  window.GS.closeFilters = closeFiltersSheet;
})();
